import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { ICampoCustomizableRequest, ICampoCustomizableResponse } from '../interfaces/campo-customizable.interface';

export interface IOpcionVariable {
  sOpcion: string;
  sValor: string;
}

export interface IOpcionVariableRequest {
  sTabla: string;
  sCampo: string;
  iIdioma: number;
}

export interface IOpcionVariableResponse {
  success: boolean;
  data: IOpcionVariable[];
}

export interface IOpcionNueva {
  opcion: string;
}

export interface IOpcionNuevaRequest {
  sCampo: string;
  sOpcion: string;
}

export interface IOpcionNuevaResponse {
  success: boolean;
  data: IOpcionNueva[];
}

export interface ICampoCustomizableSaveRequest {
  iAccion: number;
  sCampo: string;
  sCaract: string;
  iNumReg: number;
}

export interface ICampoCustomizableSaveResponse {
  success: boolean;
  data: {
    error: string;
  }[];
}

export interface IOpcionSaveRequest {
  iAccion: number;
  sCampo: string;
  sOpcion: string;
}

export interface IOpcionSaveResponse {
  success: boolean;
  data: {
    error: string;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class CamposCustomizablesService {

  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) { }

  getCamposCustomizables(request: ICampoCustomizableRequest): Observable<ICampoCustomizableResponse> {
    return this.http.post<ICampoCustomizableResponse>(`${this.apiUrl}Customizable/NvoscampList`, request);
  }

  getOpcionesCaracteristicas(): Observable<IOpcionVariableResponse> {
    const request: IOpcionVariableRequest = {
      sTabla: "nvoscamp",
      sCampo: "caracteristica",
      iIdioma: 0
    };
    return this.http.post<IOpcionVariableResponse>(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, request);
  }

  getOpcionesNuevas(sCampo: string): Observable<IOpcionNuevaResponse> {
    const request: IOpcionNuevaRequest = {
      sCampo: sCampo,
      sOpcion: ""
    };
    return this.http.post<IOpcionNuevaResponse>(`${this.apiUrl}GetMnto/GetopcnvosLst`, request);
  }

  saveCampoCustomizable(request: ICampoCustomizableSaveRequest): Observable<ICampoCustomizableSaveResponse> {
    return this.http.post<ICampoCustomizableSaveResponse>(`${this.apiUrl}GetMnto/Getnvoscamperr`, request);
  }

  saveOpcion(request: IOpcionSaveRequest): Observable<IOpcionSaveResponse> {
    return this.http.post<IOpcionSaveResponse>(`${this.apiUrl}GetMnto/Getopcnvoserr`, request);
  }

  deleteOpcion(sCampo: string, sOpcion: string): Observable<IOpcionSaveResponse> {
    const request: IOpcionSaveRequest = {
      iAccion: 3, // Eliminar
      sCampo: sCampo,
      sOpcion: sOpcion
    };
    return this.http.post<IOpcionSaveResponse>(`${this.apiUrl}GetMnto/Getopcnvoserr`, request);
  }

  createCampoCustomizable(campo: any): Observable<any> {
    return this.http.post(`${this.apiUrl}Customizable/NvoscampList`, campo);
  }

  updateCampoCustomizable(campo: any): Observable<any> {
    return this.http.put(`${this.apiUrl}Customizable/NvoscampList`, campo);
  }

  deleteCampoCustomizable(descripcion: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}Customizable/NvoscampList/${descripcion}`);
  }

  deleteCampoCustomizableReal(sCampo: string): Observable<ICampoCustomizableSaveResponse> {
    const request: ICampoCustomizableSaveRequest = {
      iAccion: 3, // Eliminar
      sCampo: sCampo,
      sCaract: "",
      iNumReg: 0
    };
    return this.http.post<ICampoCustomizableSaveResponse>(`${this.apiUrl}GetMnto/Getnvoscamperr`, request);
  }
} 